/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.warning\":[\"Varningstriangel med utropstecken\"]}");